import { createReducer } from 'redux-act';
import actions from '../actions/bulkUploadActions';

const initialState = {
  bulkUploadPending: false,
  bulkUploadRes: null,
  bulkUploadError: null,

  downloadBulkUploadSampleFilePending: false,
  downloadBulkUploadSampleFileRes: null,
  downloadBulkUploadSampleFileError: null,

};

/* Add BulkUpload Reducers */
const handleBulkUploadRequest = state => {
  return {
    ...state,
    ...{
      bulkUploadPending: true,
      bulkUploadRes: null,
      bulkUploadError: null,
    },
  };
};
const handleBulkUploadSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      bulkUploadPending: false,
      bulkUploadRes: payload,
      bulkUploadError: null,
    },
  };
};
const handleBulkUploadError = (state, payload) => ({
  ...state,
  ...{
    bulkUploadPending: false,
    bulkUploadRes: null,
    bulkUploadError: payload,
  },
});

/* Add BulkUpload Reducers */
const handleDownloadBulkUploadSampleFileRequest = state => {
  return {
    ...state,
    ...{
      downloadBulkUploadSampleFilePending: true,
      downloadBulkUploadSampleFileRes: null,
      downloadBulkUploadSampleFileError: null,
    },
  };
};
const handleDownloadBulkUploadSampleFileSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      downloadBulkUploadSampleFilePending: false,
      downloadBulkUploadSampleFileRes: payload,
      downloadBulkUploadSampleFileError: null,
    },
  };
};
const handleDownloadBulkUploadSampleFileError = (state, payload) => ({
  ...state,
  ...{
    downloadBulkUploadSampleFilePending: false,
    downloadBulkUploadSampleFileRes: null,
    downloadBulkUploadSampleFileError: payload,
  },
});


/* Clear Bulk Upload Store */
const clearBulkUploadStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_BULK_UPLOAD_STORE':
      return {
        ...state,
        ...{
          bulkUploadPending: false,
          bulkUploadRes: null,
          bulkUploadError: null,
        },
      };
      case 'HANDLE_CLEAR_DOWNLOAD_BULK_UPLOAD_SAMPLE_FILE_STORE':
      return {
        ...state,
        ...{
          downloadBulkUploadSampleFilePending: false,
          downloadBulkUploadSampleFileRes: null,
          downloadBulkUploadSampleFileError: null,
        },
      };
   
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.bulkUploadRequest]: handleBulkUploadRequest,
    [actions.bulkUploadSuccess]: handleBulkUploadSuccess,
    [actions.bulkUploadError]: handleBulkUploadError,

    [actions.downloadBulkUploadSampleFileRequest]: handleDownloadBulkUploadSampleFileRequest,
    [actions.downloadBulkUploadSampleFileSuccess]: handleDownloadBulkUploadSampleFileSuccess,
    [actions.downloadBulkUploadSampleFileError]: handleDownloadBulkUploadSampleFileError,

    [actions.handleClearBulkUploadStore]: clearBulkUploadStore,
  },
  initialState,
);